const StarIcon = ({
  style = {},
  width = 12,
  height = 12,
  fill = "#EFB841",
  stroke = "#EFB841",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      style={style}
    >
      <g clip-path="url(#clip0_1873_16807)">
        <path
          d="M6.49588 0.606598C6.65657 0.0894673 7.34343 0.0894679 7.50412 0.606597L8.64263 4.27052C8.76981 4.6798 9.1386 4.96604 9.56455 4.96604H13.2489C13.5003 4.96604 13.6836 5.13048 13.753 5.35389C13.8226 5.57789 13.7673 5.83162 13.5572 5.99126L10.5765 8.25569C10.2381 8.51283 10.1009 8.96334 10.2276 9.37125L11.3661 13.0352C11.4489 13.3016 11.346 13.5391 11.1703 13.6725C10.9962 13.8049 10.7602 13.8295 10.5537 13.6725L7.573 11.4081C7.23202 11.1491 6.76798 11.1491 6.427 11.4081L3.44634 13.6725C3.23975 13.8295 3.00383 13.8049 2.82966 13.6725C2.65403 13.5391 2.55109 13.3016 2.63388 13.0352L3.77239 9.37125C3.89914 8.96334 3.76194 8.51283 3.42347 8.25569L0.442809 5.99126C0.232676 5.83162 0.177422 5.57789 0.247028 5.35389C0.316449 5.13048 0.499739 4.96604 0.75115 4.96604H4.43545C4.8614 4.96604 5.23019 4.6798 5.35737 4.27052L6.49588 0.606598Z"
          fill={fill}
          stroke={stroke}
          strokeWidth="0.4375"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1873_16807">
          <rect width="14" height="14" fill="white"></rect>
        </clipPath>
      </defs>
    </svg>
  );
};
export default StarIcon;
